import { BaseApiV2, Methods } from "@newview/infrastructure";

export abstract class SmartSiteBaseApiV2 extends BaseApiV2 {
    public get ProxyName(): any {
        return 'ComprehensiveApi';
    }
}
